export default __webpack_public_path__ + "static/media/svg-5.99e8eaed.svg";